<template>
	<div class="bootbox modal fade in show" tabindex="-1" role="dialog" style="display: block;">
		<div :class="`modal-dialog ${popupClass}`">
			<div class="modal-content" :style="cssValue">
				<div class="modal-body" >
					<slot></slot>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props:["cssValue", "popupClass"]
}
</script>